/*
 * @Description: qiankun main
 * @Date: 2021-09-18 15:10:30
 */
import {
  registerMicroApps,
  runAfterFirstMounted,
  setDefaultMountApp,
  start
} from 'qiankun';

import apps from './micros/index';

/**
 *  注册子应用
 */
registerMicroApps(apps, {
  beforeLoad: app => {
    console.log('before load %c%s', 'color: green;', app.name);
  },
  beforeMount: [
    app => {
      console.log('before mount %c%s', 'color: green;', app.name);
    }
  ],
  afterMount: [
    app => {
      console.log('after mount %c%s', 'color: green;', app.name);
    }
  ],
  afterUnmount: [
    app => {
      console.log('after unmount %c%s', 'color: green;', app.name);
    }
  ]
});

/**
 *  设置默认进入的子应用
 */
// setDefaultMountApp('/'); 会导致主应用重载时默认跳转到/

/**
 *  启动应用
 */
start({
  sandbox: true
}); // 注意调用时机，容器 DOM 加载完成： https://qiankun.umijs.org/zh/faq#application-died-in-status-not_mounted-target-container-with-container-not-existed-while-xxx-loading

runAfterFirstMounted(() => {
  console.log('[MainApp] first app mounted');
});
